export default __webpack_public_path__ + "static/119-min-min-55b12894200d2947a0938ea5bc7c4e72.jpg";